import type DentalRaterAnswers from '@/modules/dental/rater/models/APP/DentalRaterAnswers'
import DentalRaterPriceRequest from '@/modules/dental/common/models/MID/requests/DentalRaterPriceRequest'
import CommonMapper from '@/modules/core/mappers/CommonMapper'
import type DentalRelationshipType from '@/modules/dental/common/models/DXP/DentalRelationshipType'
import type DentalHiringAnswers from '@/modules/dental/hiring/models/APP/DentalHiringAnswers'

export default class GetPricingMapper {
  static toRequest(
    data: DentalRaterAnswers | DentalHiringAnswers,
    relationships: DentalRelationshipType[],
    withClientProducts = true,
    isQuote = false,
    mediator?: string
  ): DentalRaterPriceRequest {
    const clientProduct = []
    if (data?.product) {
      clientProduct.push({
        clientCode: data?.product.clientCode,
        productCode: data?.product.productCode
      })
    }

    const insureds = data.insureds.map((i, order) => {
      let relationship = i.relationship

      if (!relationship) {
        relationship = i.isHolder
          ? relationships.find((r) => r.holder)!.id
          : relationships.find((r) => r.default && !r.disabled)!.id
      }

      return {
        postalCode: i.isHolder ? i.addressDetails.postalCode : undefined,
        birthDate: CommonMapper.toMiddlewareDate(i.userDetails.birthDate),
        riskNumber: String(order + 1),
        relationship,
        hasHealthPolicy: i.hasHealthPolicy === 'yes' ? true : false
      }
    })

    return new DentalRaterPriceRequest({
      quotationId: data.quotationId ?? undefined,
      quotationNumber: data.product?.quotationNumber
        ? Number(data.product?.quotationNumber)
        : undefined,
      businessLine: data?.businessLine ?? 'AS00',
      insuranceStartDate: CommonMapper.toMiddlewareDate(data.startDate),
      policyHolderPostal: data.policyHolderPostal,
      insureds,
      clientProduct: withClientProducts ? clientProduct : null,
      isQuote,
      mediator
    })
  }
}
